import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
// import moment from "moment";
import Header from "../../components/header/Header";
import AddCommunityMember from "../../components/addCommunityMember/AddCommunityMember";
import RangeSlider from "../../components/rangeSlider/RangeSlider";
import "./LandingPage.css";

import { isAndroid as android, isIOS as ios, osName as osname } from "react-device-detect";
import customProtocolCheck from "custom-protocol-check";

const LandingPage = (props) => {
  let navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  // const [downloadLink, setDownloadLink] = useState("");
  const [showQuest, setShowQuest] = useState(true);

  useEffect(() => {
    window.onbeforeunload = null;
  }, []);

  useEffect(() => {
    localStorage.removeItem("userMainTherapist");
    axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")) ? JSON.parse(localStorage.getItem("userData")).token : "";
    axios.post(window.ajaxLink + "user/checkOtpVerified", {}).catch((error) => {
      console.error(error);
      navigate("/verify");
    });

    var uId = JSON.parse(localStorage.getItem("userData")) ? JSON.parse(localStorage.getItem("userData")).id : 0;
    var uToken = JSON.parse(localStorage.getItem("userData")) ? JSON.parse(localStorage.getItem("userData")).token : "";

    setMoblink(android ? "intent://virdio/?userId=" + uId + "&userToken=" + uToken + "#Intent;package=com.virdio.virdiohealth;scheme=open_app;end;" : "https://deeplink.virdiohealth.com/auth/?userId=" + uId + "&token=" + uToken);

    if (osname === "Windows" || osname === "Mac OS") {
      setDownloadBtn1("Launch");
    }
  }, [navigate]);

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
    axios
      .post(window.ajaxLink + "cloud_questionnaires/get-questionnaire", { questionnaire_id: 2 })
      .then((res) => {
        if (res.data.responseData && res.data.responseData.thisQuestCompleted === 1) {
          setShowQuest(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  // const [firstName] = useState(
  //   JSON.parse(localStorage.getItem("userData")) ? JSON.parse(localStorage.getItem("userData")).first_name : ""
  // );

  const logUserOut = () => {
    localStorage.removeItem("userData");
    navigate("/");
  };

  
  const [questionnaireId, setQuestionnaireId] = useState(2);

  useEffect(() => {
    let email = JSON.parse(localStorage.getItem("userData"))?.email
    if(email){
        axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
        axios
         .post(window.ajaxLink + "cloud_questionnaires/get-patient-questionnaire", { email: email })
         .then((res) => {
          let problemId = res.data.responseData?.problem_id;
            if (problemId === 1) {
              setQuestionnaireId(2)
            } else if (problemId === 6){
              setQuestionnaireId(32)
            } else if (problemId === 5){
              setQuestionnaireId(34)
            } else if (problemId === 4){
              setQuestionnaireId(35)
            } else {
              setQuestionnaireId(2)
            }
         })
         .catch((error) => {
          console.error(error);
        });
    }
  }, [])

  const gotoQuestionnaire = () => {
    navigate(`/questionnaire/${questionnaireId}`);
  };



  const [isConfirmOpen, setConfirmOpen] = useState(false);
  const openCloseConfirmation = () => {
    setConfirmOpen(!isConfirmOpen);
  };

  const [sliderValuesRange] = useState({
    startValue: "0",
    secondValue: "01",
    thirdValue: "02",
    fourthValue: "03",
    fifthValue: "04",
    sixthValue: "05",
    seventhValue: "06",
    eighthValue: "07",
    ninthValue: "08",
    tenthValue: "09",
    endValue: "10",
  });

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")) ? JSON.parse(localStorage.getItem("userData")).token : "";

    var dateForm = JSON.parse(localStorage.getItem("userData")).birthday.split("T")[0];
    var strDate = dateForm.split("-");
    strDate = strDate[1] + "/" + strDate[2] + "/" + strDate[0];

    axios
      .post(window.ajaxLink + "user/checkForUserRequirements", {
        company_id: localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")).company_id : 0,
        firstName: localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")).first_name : "",
        lastName: localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")).last_name : "",
        dateOfBirth: localStorage.getItem("userData") ? strDate : "",
      })
      .then((res) => {
        if (!res.data.responseData.has_pain_scale) {
          setPainScaleOpen(true);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [painScaleOpen, setPainScaleOpen] = useState(false);
  const [painLevel, setPainLevel] = useState(0);
  const [painLevelError, setPainLevelError] = useState("");
  const openClosePainScale = (doSave) => {
    if (doSave) {
      if (painLevel === 0) {
        setPainLevelError("Please insert your pain level.");
        return;
      } else {
        axios.post(window.ajaxLink + "appointments/updatePainScale", { appointmentId: 0, painLevel: painLevel / 10 });
      }
    }
    setPainScaleOpen(!painScaleOpen);
  };

  const slider = (question, e, questions) => {
    const baseTen = Math.ceil(e.target.value / 10) * 10;
    setPainLevel(baseTen);
  };

  const [downloadBtn1, setDownloadBtn1] = useState("Download");
  // eslint-disable-next-line
  const [downloadBtn2, setDownloadBtn2] = useState("Download");
  const [isLinkCopied, setIsLinkCopied] = useState(false);
  const [moblink, setMoblink] = useState("");

  const [desktopOpenLink, setDesktopOpenLink] = useState(false);

  const checkDownloadLink = (linkType) => {
    var uId = JSON.parse(localStorage.getItem("userData")) ? JSON.parse(localStorage.getItem("userData")).id : 0;
    var uToken = JSON.parse(localStorage.getItem("userData")) ? JSON.parse(localStorage.getItem("userData")).token : "";

    var openUrl = "virdiohealthapp://login?userId=" + uId + "&userToken=" + uToken + "#Intent;package=com.virdio.virdiohealthapp;scheme=open_app;end";
    if (linkType === 1) {
      if (android || ios) {
        // Send download link
        // axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")) ? JSON.parse(localStorage.getItem("userData")).token : '';
        // axios.post(window.ajaxLink + "user/sendAppLinks", {}).catch((error) => { });
      } else {
        if (desktopOpenLink) {
          window.open(osname === "Windows" ? "https://apps.microsoft.com/store/detail/virdiohealth/9MXKV20X29F7" : "https://apps.apple.com/app/virdio-heath-for-desktop/id6448693919");
        } else {
          setDownloadBtn1("Opening...");
          customProtocolCheck(
            openUrl,
            () => {
              setDesktopOpenLink(true);
              setDownloadBtn1("Download");
            },
            () => {
              setDesktopOpenLink(false);
              setDownloadBtn1("Download");
            },
            10000
          );
        }
      }
    } else if (linkType === 2) {
      if (osname === "Windows" || osname === "Mac OS") {
        // Send download link
        // axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")) ? JSON.parse(localStorage.getItem("userData")).token : '';
        // axios.post(window.ajaxLink + "user/sendAppLinks", {}).catch((error) => { });
      }
    }
  };
  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(moblink)
      .then(() => {
        setIsLinkCopied(true);
        setTimeout(() => {
          setIsLinkCopied(false);
        }, 2000); // Hide tooltip after 2 seconds
      })
      .catch((err) => console.error("Unable to copy link", err));
  };
  return (
    <>
      <Header />

      <div className="landing_main_grid">
        <div className="landing_boxes">
          <div className="landing_stepc">Step 1</div>
          <div className="landing_title">Complete your questionnaire prior to your telehealth call</div>
          <div className="landing_inside_box">
            {!loading && showQuest === true && (
              <>
                <div className="allset_checklist_flex">
                  <div className="allset_checklist">
                    <div className="allset_checklist_icon allset_checklist_icon1"></div>
                    <div className="allset_checklist_desc">Your Therapist needs you to answer a couple of questions on your pain level and daily life prior to your tele-health call.</div>
                  </div>
                  <div className="allset_checklist">
                    <div className="allset_checklist_icon allset_checklist_icon2"></div>
                    <div className="allset_checklist_desc">This is required to be completed prior to your 1-1 call with your Therapist.</div>
                  </div>
                  <div className="allset_checklist">
                    <div className="allset_checklist_icon allset_checklist_icon3"></div>
                    <div className="allset_checklist_desc">Complete now or later.</div>
                  </div>
                </div>
                <div className="next_btn_questionare add_comm_btn" onClick={() => gotoQuestionnaire()}>
                  Start Questionnaire
                </div>
              </>
            )}

            {!loading && showQuest === false && (
              <>
                <div className="allset_checklist_flex">
                  <div className="allset_checklist">
                    <div className="allset_checklist_icon allset_checklist_icon1"></div>
                    <div className="allset_checklist_desc">You have already answered the questionnaire.</div>
                  </div>
                </div>
              </>
            )}
            {loading && (
              <div className="allset_checklist_flex" style={{ width: "100%" }}>
                <div className="p_load"></div>
              </div>
            )}
          </div>
        </div>
        <div className="landing_boxes landing_boxes_green">
          <div className="landing_stepc">Step 2</div>
          <div className="landing_title">
            Supercharge
            <br />
            Your Recovery!
          </div>
          <div className="landing_title_small">Invite your friends and family.</div>
          <div className="landing_inside_box">
            <div className="allset_checklist_flex">
              <div className="allset_checklist">
                <div className="allset_checklist_icon allset_checklist2_icon1"></div>
                <div className="allset_checklist_desc">Emotional Support.</div>
              </div>
              <div className="allset_checklist">
                <div className="allset_checklist_icon allset_checklist2_icon2"></div>
                <div className="allset_checklist_desc">Practical Assistance with difficult tasks.</div>
              </div>
              <div className="allset_checklist">
                <div className="allset_checklist_icon allset_checklist2_icon3"></div>
                <div className="allset_checklist_desc">Better Undestanding.</div>
              </div>
            </div>
            <div
              className="next_btn_questionare add_comm_btn"
              onClick={() => {
                window.memberPopupOpen();
              }}
            >
              Add a Support Team
            </div>

            <div className="landing_sub_purple">improve overall program outcome and recovery by 25% *</div>
            <div className="landing_sub_gray">*Source: University of Pittsburgh Medical Center Study</div>
          </div>
        </div>
        <br />
        <div className="landing_boxes">
          <div className="landing_boxes_bgimage">&nbsp;</div>
        </div>
        <div className="landing_boxes">
          <div className="landing_stepc">Step 3</div>
          <div className="landing_title">
            Final step left -<br />
            download the app!
          </div>
          <div className="landing_inside_box">
            <div className="allset_explain">
              VirdioHealth programs can only be attended
              <br />
              in the VirdioHealth apps, get started by downloading the
              <br />
              VirdioHealth apps for your devices.
            </div>
            <div className="download_section">
              <div className="qr_image_handler">
                <div className="allset_dnld_text qr_image_text">Scan to download the mobile app</div>
                <div className="allset_qr_link"></div>
              </div>
              <div className="allset_download_hold ">
                <div className="allset_dnld_inner allset_dnld_inner1">
                  <div className="allset_dnld_icon as_dnld_desktop"></div>
                  <div className="allset_dnld_desc">
                    <div className="allset_dnld_title">
                      Download
                      <br />
                      desktop app
                    </div>
                  </div>
                </div>
                <div className="allset_dnld_link" onClick={() => checkDownloadLink(1)}>
                  {downloadBtn1}
                </div>
              </div>
              <div className="allset_download_hold">
                <div className="allset_dnld_inner">
                  <div className="allset_dnld_icon as_dnld_mobile"></div>
                  <div className="allset_dnld_desc">
                    <div className="allset_dnld_title">
                      Download
                      <br />
                      mobile app
                    </div>
                  </div>
                  <div className="copy-icon" onClick={handleCopyLink} aria-label="Copy Link"></div>
                </div>
                {android || ios ? (
                  <a href={moblink}>
                    <div className="allset_dnld_link">{downloadBtn2}</div>
                  </a>
                ) : (
                  <>
                    <div className="allset_dnld_link" onClick={() => checkDownloadLink(2)}>
                      {downloadBtn2}
                    </div>
                  </>
                )}

                {isLinkCopied && <span className="tooltip">Copied!</span>}
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddCommunityMember isLandingPage={true} />

      {isConfirmOpen && (
        <div className="approval_wrapper">
          <div className="approval_close" onClick={() => openCloseConfirmation()}></div>
          <div className="dbl_place_on_page">
            <div className="approval_popup">
              <div className="ap_title">Are you sure you want to finish this questionnaire later?</div>
              <div className="ap_explain">If you prefer to complete the Lower back pain questionnaire later, we will remind you by email before your scheduled one-on-one call with your therapist.</div>
              <Link to={"/landing"} style={{ textDecoration: "none" }}>
                <div className="ap_button apb_confirm">Yes, remind me</div>
              </Link>
              <div className="ap_button" onClick={() => openCloseConfirmation()}>
                No, go to back
              </div>
            </div>
          </div>
        </div>
      )}
      {painScaleOpen && (
        <div className="approval_wrapper">
          <div className="dbl_place_on_page">
            <div className="approval_popup">
              <div className="ap_explain ap_pain_explain">Tell us about your level of pain on a scale of 1 to 10?</div>
              <RangeSlider percentage={painLevel} sliderPercentage={slider} question={"Tell us about your level of pain on a scale of 1 to 10?"} questions={[]} sliderValuesRange={sliderValuesRange} isInError={painLevelError} />
              {painLevelError && <div className="email_error_msg">{painLevelError}</div>}
              <div className="ap_button ap_pain_button" onClick={() => openClosePainScale(true)}>
                Update
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="landing_logout">
        <Link to={"/"} onClick={() => logUserOut()}>
          <div className="landing_logout_icon"></div> Log Out
        </Link>
      </div>
    </>
  );
};

export default LandingPage;
